<template>
<div v-if="address && address.id">

    <div :class="{ 'panel panel-clinic': from == 'address' }">

        <div class="panel-heading" v-if="from == 'address'">
            <h2 class="panel-title">Adressuppgifter</h2>
        </div>

        <div class="modal-header" v-if="from != 'address'">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title" v-if="address_id == 'new'">Lägg till ny adress</h4>
            <h4 class="modal-title" v-if="address_id != 'new'">Redigera {{ address.street }}</h4>
        </div>

        <div class="panel-collapse">
            <div :class="{ 'panel-body': from == 'address', 'modal-body': from != 'address' }">

                <div style="float: left; width: 100%;">

                    <div class="half-width-form">

                        <div class="clinic-outer-form-group">

                            <div class="form-group oddevencol">
                                <label for="title" class="control-label">Titel för Benify/Location</label>
                                <input type="text" class="form-control" name="title"  v-model="address.title">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="co" class="control-label">c/o Adress</label>
                                <input type="text" class="form-control" name="co"   v-model="address.co">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="street" class="control-label">Gata <span class="public-data" title="Visas på hemsidan">*</span></label>
                                <input type="text" class="form-control" id="street" name="street"  v-model="address.street">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="city_area" class="control-label">Orter/område för fritextsökning</label>
                                <input type="text" class="form-control" id="city_area" name="city_area" v-model="address.city_area">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="city" class="control-label">Postort <span class="public-data" title="Visas på hemsidan">*</span></label>
                                <input type="text" class="form-control" id="city" name="city" v-model="address.city">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="seo_area" class="control-label">Kommun</label>
                                <input type="text" class="form-control" name="seo_area"  v-model="address.seo_area">
                            </div>

                            <div class="form-group oddevencol">
                                <label for="zip" class="control-label">Postnummer <span class="public-data" title="Visas på hemsidan">*</span></label>
                                <input type="text" class="form-control" id="zip" name="zip" v-model="address.zip">
                            </div>

                            <div class="form-group oddevencol" style="display: none;">
                                <label for="coordinates" class="control-label">Kordinater</label>
                                <input type="text" class="form-control" id="coordinates" name="coordinates" v-model="address.coordinates">
                            </div>

                            <span v-if="submited">
                                Sparar...
                            </span>

                            <button type="submit" class="btn btn-default pull-right" style="margin-top: 20px;" :disabled="submited" @click="save()">
                                Spara
                            </button>

                        </div>
                    </div>

                    <div class="half-width-form" style="height: 805px; margin-bottom: 20px;">

                        <div class="form-group oddevencol">
                            <label for="title" class="control-label">Sök adress</label>
                            <p>Sök efter adressen och välj en träff i listan. Positionen väljs då automatiskt på kartan och Gata, ort och postnummer kopieras över till adressfälten.<br> Får du ingen träff på adressen? Skriv då in den manuellt i fälten till vänster. Du behöver därefter justera positionen på kartan manuellt. Dra först pekaren till rätt stad. Zooma därefter in och dra den till rätt adress.</p>
                            <google-autocomplete
                                ref="autocomplete"
                                id="map-autocomplete"
                                classname="form-control"
                                placeholder="Sök adress"
                                types="address"
                                country="se"
                                @placechanged="getAddressData"
                            >
                            </google-autocomplete>
                        </div>

                        <google-map
                            ref="gmap"
                            v-model="address.coordinates"
                        >
                        </google-map>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <br clear="all" v-if="from != 'address'">

    <div class="panel panel-clinic" v-if="address_id != 'new'">
        <div class="panel-heading" href="#clinics_logg" data-toggle="collapse">
            <div class="arrow-down"></div>
            <h2 class="panel-title">Partners kopplade till adressen</h2>
        </div>

        <div id="clinics_logg" class="panel-collapse collapse">
            <div class="panel-body">
                <form-log-clinics :address="address"></form-log-clinics>
            </div>
        </div>
    </div>

    <div class="panel panel-clinic">
        <div class="panel-heading" href="#active_logg" data-toggle="collapse">
            <div class="arrow-down"></div>
            <h2 class="panel-title">Logg över upp/ner från portal</h2>
        </div>

        <div id="active_logg" class="panel-collapse collapse">
            <div class="panel-body">
                <form-log-active :address="address"></form-log-active>
            </div>
        </div>
    </div>

</div>
</template>

<script>

import formLogActive from './form-log-active'
import formLogClinics from './form-log-clinics'
import googleAutocomplete from './google-autocomplete'
import googleMap from './google-map'

export default {

    components: {
        formLogActive,
        formLogClinics,
        googleAutocomplete,
        googleMap
    },

    props: {
        from: {
            default: 'address'
        },
        address_id: {
            required: true
        }
    },

    data () {
        return {
            address: {},
            submited: false
        }
    },

    created () {
        this.fetch()
    },

    watch: {

        address_id () {
            this.fetch()
        }

    },

    methods: {

        fetch () {
            this.$http.get('/addresses/' + this.address_id)
                .then((response) => {
                    console.log('get addresses response')
                    console.log(response.data)

                    this.address = response.data.address
                    if (this.address_id == 'new') {
                        this.address.coordinates = '59.32705187003904 18.07175792393309'
                    }
                }, (response) => {
                    console.log(JSON.stringify(response))
                })
        },

        getAddressData (addressData, placeResultData, id) {
            if (!this.address.street || confirm('Vill du skriva över den befintliga adressen')) {
                this.address.street = addressData.route + '' + (addressData.street_number ? ' ' + addressData.street_number : '')
                this.address.city = addressData.postal_town ? addressData.postal_town : ''
                this.address.zip = addressData.postal_code ? addressData.postal_code.replace(/\s+/g, '') : ''
            }

            this.address.coordinates = addressData.latitude + ' ' + addressData.longitude

            this.$nextTick(() => {
                this.$refs.autocomplete.clear()
                this.$refs.gmap.zoomToMarker()
            })
        },

        save () {
            if (this.submited) {
                return
            }

            this.submited = true

            this.$http.post(
                '/addresses/' + this.address_id,
                this.address
            )
                .then((response) => {
                    console.log('save addresses response')
                    console.log(response)

                    this.submited = false

                    if (this.from == 'address') {
                        window.location.href = '/addresses'
                        return
                    }

                    if (this.from == 'clinic' && this.address_id == 'new') {
                        this.$emit('addressCreated', response.data.address)
                    }

                    if (this.from == 'clinic' && this.address_id != 'new') {
                        this.$emit('addressUpdated', response.data.address)
                    }
                }, (response) => {
                    console.log(JSON.stringify(response))

                    this.submited = false
                })
        }

    }

}

</script>
